<template>
  <section class="section content-container">
    <n-loading-spinner v-if="isLoading" />
    <div class="container is-fluid" v-show="!isLoading">
      <div class="island">
        <nav class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <p class="level-item">
              <n-button @click="showInviteUserModal = true" variant="primary">
                <span>Invite new Admins</span>
              </n-button>
            </p>
          </div>
        </nav>

        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Created</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>{{ user.displayName }}</td>
              <td>{{ user.userId }}</td>
              <td>{{ formatDate(user.createdTimeUtc) }}</td>
              <td>
                <span class="tag" :class="getStatusClass(user.status)">{{ getStatus(user.status) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <InviteUser v-if="showInviteUserModal" user-term="admin" invite-platform-admins @close="handleInviteModalClosed" />
</template>

<script lang="ts" setup>
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { onBeforeMount, ref } from 'vue';
import { workspacesApi } from '@/workspaces/workspaces';
import { store } from '@/store';
import { UserViewModel } from '@/workspaces/models/userViewModel';
import moment from 'moment';
import InviteUser from '@/features/settings/components/InviteUser.vue';

const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);
const users = ref<UserViewModel[]>([]);
const isLoading = ref(false);
const showInviteUserModal = ref(false);

onBeforeMount(async () => {
  await loadPlatformAdminUsers();
});

async function loadPlatformAdminUsers() {
  isLoading.value = true;

  try {
    users.value = await workspacesApi.getAllPlatformAdminUsers();
  } catch (err: any) {
    await handleSeriousError(err.message);
  } finally {
    isLoading.value = false;
  }
}

function getStatus(status: number): string {
  if (status === 0) {
    return 'Pending';
  } else if (status === 1) {
    return 'Active';
  }
  return '';
}

function getStatusClass(status: number): string {
  if (status === 0) {
    return 'is-warning';
  } else if (status === 1) {
    return 'is-success';
  }
  return 'is-danger';
}

function formatDate(value: string): string {
  return moment(String(value)).format('DD MMM YYYY');
}

async function handleInviteModalClosed(invited: boolean) {
  showInviteUserModal.value = false;
  if (invited) {
    await loadPlatformAdminUsers();
  }
}
</script>
